import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import classNames from 'classnames'
import React from 'react'

import { exportData } from 'src/commons/export/Export'
import ChartContainer, { IToggleIcon } from 'src/components/ChartContainer'

import { useGraphContext } from './GraphWrappers'
import { exportDeckGLChartToImg, exportReactChart2ToImg } from './utils'

export interface IChartWrapperProps {
  bannerMessage?: string
  children: React.ReactNode
  customExport?: (filename: string, data?: any) => void
  data: any
  description?: string
  formatExportBuckets?: (data: any) => Record<string, unknown>
  formatExportFeatures?: (data: any) => Record<string, unknown>
  halfContainer?: boolean
  id?: string
  loading: boolean
  title: string
  toggles?: IToggleIcon[]
}

export default function ChartWrapperContent(props: IChartWrapperProps) {
  const classes = useStyles()
  const { reactChart, deckGL } = useGraphContext()

  let onExport
  if (props.formatExportBuckets) {
    const rows = props.data || []
    onExport = () => exportData(props.title, rows, props.formatExportBuckets!, true)
  } else if (props.formatExportFeatures) {
    const geojson = props.data || { features: [] }
    const rows = geojson.features
    onExport = () => exportData(props.title, rows, props.formatExportFeatures!, true)
  } else if (props.customExport) {
    onExport = () => props.customExport!(props.title, props.data)
  }

  const exportGraphImage = () => {
    // solution from https://stackoverflow.com/questions/62039681/react-chartjs-2-doughnut-chart-export-to-png
    // If better solution don't hesitate :)
    if (!!reactChart.chartRef?.current) {
      exportReactChart2ToImg(reactChart)
    }

    // Case of Mabbox GL graph export (Choropleth,...)
    if (!!deckGL.deckRef?.current) {
      exportDeckGLChartToImg(deckGL)
    }
  }

  const isBigScreen = useMediaQuery('(min-width:1600px)')
  return (
    <div
      id={props.id}
      className={classNames(classes.chartContainer, props.halfContainer && isBigScreen ? classes.halfContainer : '')}
    >
      <ChartContainer
        loading={props.loading}
        title={props.title}
        onExport={onExport}
        onImageExport={exportGraphImage}
        description={props.description}
        toggles={props.toggles}
        bannerMessage={props.bannerMessage}
      >
        {props.children}
      </ChartContainer>
    </div>
  )
}

const useStyles = makeStyles(() => ({
  chartContainer: {
    flex: '1 1 100%',
  },
  halfContainer: {
    flex: '1 1 50%',
    width: '50%',
  },
}))
